import { KeyedMutator } from "swr";
import { useCallback } from "react";
import { closeRecommendationBanner } from "@modules/eirCustomersFacade/api";
import { useFetchState } from "@hook/useFetchState";

interface IParams {
    mutate: KeyedMutator<string>;
}

export const useRecommendationBannerRemovalModal = (props: IParams) => {
    const { mutate } = props;
    const { startFetching, endFetching, isLoading: isRecommendationBannerClosing, error } = useFetchState();

    const handleCloseRecommendationBanner = useCallback(async () => {
        if (isRecommendationBannerClosing) {
            return false;
        }

        try {
            startFetching();
            await closeRecommendationBanner();
            await mutate().catch(() => false);
            endFetching();

            return true;
        } catch (closeError) {
            endFetching(closeError);

            return false;
        }
    }, [endFetching, isRecommendationBannerClosing, mutate, startFetching]);

    return { handleCloseRecommendationBanner, isRecommendationBannerClosing, error };
};
